module.exports = __webpack_public_path__ + "img/bg.8c96f05c.jpeg";